import { render, staticRenderFns } from "./selectProduct.vue?vue&type=template&id=03cd88c7&scoped=true"
import script from "./selectProduct.vue?vue&type=script&lang=js"
export * from "./selectProduct.vue?vue&type=script&lang=js"
import style0 from "./selectProduct.vue?vue&type=style&index=0&id=03cd88c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd88c7",
  null
  
)

export default component.exports